/** Botlogs de conciliación automática (toast vía WS en Header). */
export const RECONCILIATION_BOTLOG_BOTNAMES = new Set([
  'conciliacion-automatica',
  'conciliacion-automatica-llm',
  'conciliacion-automatica-cron',
  'conciliacion-heuristica',
  'conciliacion-llm',
  'conciliacion-capas',
  'conciliacion-capas-diurna',
  'conciliacion_llm_polling',
]);

const LOCK_RE =
  /reconciliaci[oó]n en curso|liberar\s*lock|ya hay una conciliaci/i;
const TIMEOUT_RE =
  /timeout|polling de heur|polling de llm|tard[oó] demasiado/i;
const TECHNICAL_RE =
  /source=|job=|correlationid|layersonly=|matches nativos=/i;

const FRIENDLY = {
  lock:
    'Ya hay una conciliación en curso para esta empresa. Espera a que termine o inténtalo más tarde.',
  timeout:
    'La conciliación automática tardó demasiado en responder. Puedes reintentarla más tarde.',
  heuristic:
    'No se pudo completar la conciliación automática. Inténtalo nuevamente más tarde.',
  generic:
    'No pudimos completar la conciliación automática. Inténtalo nuevamente.',
  success: 'Conciliación automática finalizada correctamente.',
};

export function isReconciliationBotlog(botname) {
  return RECONCILIATION_BOTLOG_BOTNAMES.has(String(botname || '').toLowerCase());
}

export function getFriendlyBotlogTitle(botname) {
  if (isReconciliationBotlog(botname)) return 'Conciliación automática';
  return botname;
}

/**
 * Mensaje visible para el usuario. El detalle técnico debe ir a console (Header) o logs (backend).
 */
export function getFriendlyReconciliationError(rawMessage) {
  if (rawMessage == null || rawMessage === '') return FRIENDLY.generic;
  const msg = String(rawMessage).trim();

  if (LOCK_RE.test(msg)) return FRIENDLY.lock;
  if (TIMEOUT_RE.test(msg)) return FRIENDLY.timeout;
  if (/heur[ií]stica error|llm error|error en conciliaci/i.test(msg)) return FRIENDLY.heuristic;
  if (TECHNICAL_RE.test(msg) || (msg.includes('|') && msg.length > 80)) return FRIENDLY.generic;
  if (msg.length > 160) return FRIENDLY.generic;

  return msg;
}

export function getFriendlyBotlogToastContent(botname, mssg, ok) {
  if (ok) {
    if (mssg === 'Ejecutado de forma correcta') return FRIENDLY.success;
    if (isReconciliationBotlog(botname) && TECHNICAL_RE.test(String(mssg || ''))) {
      return FRIENDLY.success;
    }
    return mssg;
  }
  return getFriendlyReconciliationError(mssg);
}

export function logReconciliationTechnicalError(context, technicalMessage, extra) {
  if (typeof console !== 'undefined' && console.warn) {
    console.warn(`[${context}]`, technicalMessage, extra ?? '');
  }
}

/** Extrae mensaje crudo de errores GraphQL/urql (solo para logs). */
export function extractGraphQLErrorMessage(error, fallback = 'Error desconocido') {
  if (!error) return fallback;
  if (error.graphQLErrors?.length > 0) {
    const g = error.graphQLErrors[0];
    return g.message || g.extensions?.message || JSON.stringify(g);
  }
  if (error.networkError) return error.networkError.message || 'Error de conexión';
  if (error.message) return error.message;
  if (typeof error === 'string') return error;
  if (typeof error === 'object') return error.message || error.error || String(error);
  return fallback;
}
